import "core-js/modules/es.array.push.js";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "manage-header"
};
const _hoisted_2 = {
  class: "manage-right"
};
const _hoisted_3 = {
  class: "user-avatar-wrapper"
};
const _hoisted_4 = {
  class: "user-avatar"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "user-info-panel"
};
const _hoisted_7 = {
  class: "user-info-avatar"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "user-info-detail"
};
const _hoisted_10 = {
  class: "user-info-name"
};
const _hoisted_11 = {
  class: "user-info-phone"
};
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { HomeFilled, SwitchButton } from "@element-plus/icons-vue";
import ManageAside from "./ManageAside.vue";
import { getUserData, clearUserData } from "@/utils/auth";
import request from "@/utils/request";
import toast from "@/utils/toast";
export default {
  __name: 'ManageLayout',
  setup(__props) {
    const $router = useRouter();

    // 用户数据
    const userData = getUserData();

    // 处理下拉菜单命令
    const handleCommand = async command => {
      if (command === "home") {
        // 返回首页
        $router.push({
          name: "competition-list"
        });
      } else if (command === "logout") {
        // 退出登录
        await logout();
      }
    };

    // 退出登录
    const logout = async () => {
      try {
        const res = await request.post("/api/v1/user/logout");
        if (res.code === 200) {
          clearUserData();
          toast("退出成功");
          $router.push("/");
        } else {
          toast(res.msg || "退出失败");
        }
      } catch (err) {
        console.error(err);
        toast("退出失败");
      }
    };
    onMounted(() => {
      // 可以在这里刷新用户数据
    });
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "manage-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, {
          class: "manage-header-wrapper"
        }, {
          default: _withCtx(() => [_renderSlot(_ctx.$slots, "header", {}, () => [_createElementVNode("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "manage-left"
          }, [_createElementVNode("span", {
            class: "header-icon"
          }, "◆"), _createElementVNode("span", {
            class: "header-title"
          }, "芒果灵创 赛事管理后台")], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dropdown, {
            trigger: "hover",
            onCommand: handleCommand
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                command: "info"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_unref(userData)?.avatar ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(userData)?.avatar,
                  style: {
                    "width": "100%",
                    "height": "100%",
                    "object-fit": "cover"
                  }
                }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_createTextVNode("🌊")], 64))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_unref(userData)?.realname || "管理员"), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(userData)?.phoneMask || "-"), 1)])])]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "home",
                divided: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(HomeFilled))]),
                  _: 1
                }), _cache[0] || (_cache[0] = _createTextVNode(" 返回首页 ", -1))]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "logout"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(SwitchButton))]),
                  _: 1
                }), _cache[1] || (_cache[1] = _createTextVNode(" 退出登录 ", -1))]),
                _: 1
              })]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_unref(userData)?.avatar ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(userData)?.avatar,
              style: {
                "width": "100%",
                "height": "100%",
                "object-fit": "cover"
              }
            }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode("🌊")], 64))])])]),
            _: 1
          })])])])]),
          _: 3
        }), _createVNode(_component_el_container, {
          class: "manage-body"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            width: "240px",
            class: "manage-aside-wrapper"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [_renderSlot(_ctx.$slots, "aside", {}, () => [_createVNode(ManageAside)])]),
              _: 3
            })]),
            _: 3
          }), _createVNode(_component_el_container, {
            class: "manage-main-wrapper"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_main, {
              class: "manage-main"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [_createVNode(_component_router_view)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 3
        })]),
        _: 3
      });
    };
  }
};